// @flow
import moment from "moment";
import momentDE from "moment/locale/de";

moment.updateLocale("de", momentDE);

/*
 * JavaScript Pretty Date
 * Copyright (c) 2011 John Resig (ejohn.org)
 * Licensed under the MIT and GPL licenses.
 */

// Takes an ISO time and returns a string representing how
// long ago the date represents.
function prettyDateStr(time){
  const date = new Date((time || "").replace(/-/g, "/").replace(/[TZ]/g, " ")),
    diff = (((new Date()).getTime() - date.getTime()) / 1000),
    day_diff = Math.floor(diff / 86400);

  if ( isNaN(day_diff) || day_diff < 0 || day_diff >= 31 )
    return;

  return day_diff === 0 && (
    diff < 60 && "gerade eben" ||
    diff < 120 && "vor einer Minute" ||
    diff < 3600 && Math.floor("vor " + diff / 60 ) + " Minuten" ||
    diff < 7200 && "vor einer Stunde" ||
    diff < 86400 && Math.floor("vor " + diff / 3600 ) + " Stunden") ||
    day_diff === 1 && "Gestern" ||
    day_diff < 7 && "vor " + day_diff + " Tagen" ||
    day_diff < 31 && "vor " + Math.ceil( day_diff / 7 ) + " Wochen";
}

const today = moment();

function dayAndDate(date: string, fullYear: boolean) {
  const dateObj = moment(date);
  if (today.isSame(dateObj, "day")) {
    return "Heute";
  }
  if (moment(date).subtract(1, "days").isSame(today, "day")) {
    return "Morgen";
  }
  if (fullYear) {
    return dateObj.format("dd, DD.MM.YYYY");
  }
  if (today.isSame(dateObj, "year")) {
    return dateObj.format("dd, DD.MM.");
  }
  return dateObj.format("dd, DD.MM.YY");
}

function prettyDate(date: string) {
  const dateObj = moment(date);
  if (today.isSame(dateObj, "day")) {
    return "Heute";
  }
  if (moment(date).subtract(1, "days").isSame(today, "day")) {
    return "Morgen";
  }

  return dateObj.format("DD.MM.YYYY");
}

function ISODate(date: string) {
  return moment(date).format("DD.MM.YYYY");
}

function ISODateAndTime(date: string) {
  return `${moment(date).format("DD.MM.YYYY, HH:mm")} Uhr`;
}

function dayAndTime(date: string) {
  const dateObj = moment(date);
  return `${dateObj.format('dd, HH:mm')} Uhr`
}

function time(date: string) {
  return moment(date).format("HH:mm");
}

function dateAndTime(date: string) {
  return moment(date).format("dd, DD.MM, HH:mm")
}

function prettyPastDate(date: string) {
  const pretty = prettyDateStr(date);
  if(pretty) {
    return pretty;
  }
  return moment(date).format("dd., DD.MM.YYYY, HH:mm")
}

const formatDates = {
  dayAndDate,
  time,
  ISODate,
  dayAndTime,
  dateAndTime,
  prettyDate,
  ISODateAndTime,
  prettyPastDate
};

export default formatDates;
